import type { MiddlewareAPI } from 'redux';
import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { CAN_DELETE_ISSUES } from '../../model/config/permissions/constants';
import fetch, { type Response } from '../../rest/load-additional-data';
import { getBaseUrl, getIsCompanyManaged, getRapidViewId } from '../../state/selectors/app';
import type { State } from '../../state/types';

export const transformer = (response: Response, isCompanyManaged: boolean) => ({
	config: {
		permissions: !isCompanyManaged
			? {
					[CAN_DELETE_ISSUES]: response.canDeleteIssues,
				}
			: {},
		isInlineCardCreateEnabled: response.isInlineCardCreateEnabled,
	},
});

export type AdditionalBoardData = ReturnType<typeof transformer>;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (store: MiddlewareAPI<State>): ObservableType<AdditionalBoardData> => {
	const state = store.getState();
	const baseUrl = getBaseUrl(state);
	const rapidViewId = getRapidViewId(state);
	const isCompanyManaged = getIsCompanyManaged(state);

	return fetch(baseUrl, rapidViewId).map((response) => transformer(response, isCompanyManaged));
};
